import React, { useRef, useEffect, useState, useCallback } from "react";
import { debounce } from "lodash";

import echarts from "./echarts";

import defaultTheme from "./defaultTheme.json";

interface IProps {
  theme?: Object | string;
  option: echarts.EChartsCoreOption;
}

const Charts: React.FC<IProps> = ({ option }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const [chartInstance, setChartInstance] = useState<echarts.ECharts | null>(null);

  useEffect(() => {
    if (chartRef && chartRef.current && !chartInstance) {
      const renderedInstance = echarts.init(chartRef.current, defaultTheme.theme, {
        renderer: "canvas",
      });
      setChartInstance(renderedInstance);
    }
    return () => {
      if (chartInstance) {
        chartInstance.dispose();
      }
    };
  }, [chartRef, chartInstance]);

  useEffect(() => {
    if (!chartInstance || !option) return;
    chartInstance.setOption(option, { notMerge: true });
  }, [chartInstance, option]);

  const handleWindowResize = useCallback(
    debounce(() => {
      if (chartRef && chartRef.current) {
        const renderedInstance = echarts.getInstanceByDom(chartRef.current);
        renderedInstance && renderedInstance.resize();
      }
    }, 300),
    [chartRef]
  );

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize, false);

    return () => {
      window.removeEventListener("resize", handleWindowResize, false);
    };
  }, [handleWindowResize]);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div style={{ width: "100%", height: "100%", overflow: "hidden" }} ref={chartRef} />
    </div>
  );
};

export default Charts;
